export const getItems = (state, items) => {
    state.items = items;
};

export const addItem = (state, item) => {
    state.items.data = [item, ...state.items.data];
};

export const updateItem = (state, item) => {
    const itemIdx = state.items.data.findIndex(
        (_item) => _item.id === item.id
    );
    if (itemIdx < 0) {
        return;
    }
    state.items.data[itemIdx] = item;
};

export const deleteItem = (state, item) => {
    const items = state.items.data.filter(
        (_item) => _item.id !== item.id
    );
    state.items.data = items;
};

export const getCategories = (state, categories) => {
    state.categories = categories;
};

export const publishItem = (state, item) => {
    const idx = state.items.data.findIndex(i => i.id === item.id);
    if (idx >= 0) state.items.data[idx] = item;
};

export const attachPlan = (state, item) => {
    const idx = state.items.data.findIndex(i => i.id === item.id);
    if (idx >= 0) state.items.data[idx] = item;
};

export const detachPlan = (state, item) => {
    const idx = state.items.data.findIndex(i => i.id === item.id);
    if (idx >= 0) state.items.data[idx] = item;
};

export const addVariant = (state, { itemId, variant }) => {
    const item = state.items.data.find(i => i.id === itemId);
    if (item) item.variants = [...(item.variants || []), variant];
};

export const removeVariant = (state, { itemId, variantId }) => {
    const item = state.items.data.find(i => i.id === itemId);
    if (item) item.variants = (item.variants || []).filter(v => v.id !== variantId);
};

const ItemMutation = {
    getItems,
    addItem,
    updateItem,
    deleteItem,
    getCategories,
    publishItem,
    attachPlan,
    detachPlan,
    addVariant,
    removeVariant,
};

export default ItemMutation;